import React from 'react'
import { CountryPreferenceProduct } from '@/api/Clients/Types/CountryPreferenceProduct'
import { fetchCountriesAction } from '@/store/identity/identity.actions'
import { useApiClient } from '@/utils/api/ApiClient'
import { IdentityApiClient } from '@/utils/api/identityApi'
import { isEmpty } from '@/utils/is-empty'
import { GridFilterCellProps } from '@progress/kendo-react-grid'
import { multiSelectFilterCell } from 'components/Filter/FilterCell'
import { SelectValue } from 'components/Filter/FilterCell/MultiSelectFilterCell'
import { useAppDispatch, useAppSelector } from 'store'

export const TickmillCompanyFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const tickmillCompanies = useAppSelector((state) => state.identity.tickmillCompanies)

  return multiSelectFilterCell({
    items: tickmillCompanies.map((x) => ({ id: x.id, value: x.name, label: x.name })),
  })(props)
}

export const CountryFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const countries = useAppSelector((state) => state.identity.countries)
  const dispatch = useAppDispatch()
  const identityApiClient = useApiClient(IdentityApiClient)

  if (isEmpty(countries)) {
    dispatch(fetchCountriesAction(identityApiClient))
  }
  return multiSelectFilterCell({
    items: countries.map((x) => ({ id: x.id, value: x.name, label: x.name })),
  })(props)
}

export const ProductFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const tickmillProducts = useAppSelector((state) => state.clients.tickmillProducts)

  return multiSelectFilterCell({
    items: tickmillProducts.map((x) => ({ id: x.id, value: x.name, label: x.name })),
    options: {
      operator: productOperator,
    },
  })(props)
}

const productOperator = (
  values: CountryPreferenceProduct[] | null | undefined,
  selectedValues: SelectValue[]
) => {
  const availableNames = new Set(
    (values ?? []).flatMap((value) => [
      value.name,
      ...(value.subProducts ?? []).map((subProduct) => subProduct.name),
    ])
  )

  return selectedValues.every((selectedValue) => availableNames.has(String(selectedValue)))
}

const companiesOperator = (
  value: { company: { name: string } }[],
  selectedValues: SelectValue[]
) => {
  if (selectedValues.length === 0) {
    return true
  }

  return selectedValues.find((selectedName) => {
    return !!value.find((x) => x.company.name === selectedName)
  })
}

export const CompaniesFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const tickmillCompanies = useAppSelector((state) => state.identity.tickmillCompanies)

  return multiSelectFilterCell({
    items: tickmillCompanies.map((x) => ({ id: x.id, value: x.name, label: x.name })),
    options: {
      operator: companiesOperator,
    },
  })(props)
}
